import React from 'react';
import { Clock, Download } from 'lucide-react';
import type { Document, Category } from '@/lib/types';
import { formatDate } from '@/lib/types';

interface RecentlyUpdatedProps {
  docs: Document[];
  categories: Category[];
}

export default function RecentlyUpdated({ docs, categories }: RecentlyUpdatedProps) {
  const getCategoryName = (doc: Document) =>
    (doc.category as any)?.name ??
    categories.find((c) => c.id === doc.category_id)?.name ??
    '';

  return (
    <div className="mb-6 sm:mb-8">
      <div className="flex items-center gap-2 mb-3">
        <Clock size={14} className="text-primary" aria-hidden="true" />
        <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-widest">
          Recently Updated
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3">
        {docs.map((doc) => {
          const catName = getCategoryName(doc);
          return (
            <div
              key={`recent-${doc.id}`}
              className="flex items-center gap-3 p-3 bg-card border border-blue-100 rounded-xl hover:border-primary/30 transition-all duration-150 group"
            >
              <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                <Download size={14} className="text-primary" aria-hidden="true" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold text-foreground truncate">{doc.title}</p>
                <p className="text-xs text-muted-foreground truncate">
                  {catName}{catName ? ' • ' : ''}{formatDate(doc.updated_at)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}